<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage" @load="loadSummary">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="商户信息" colspan="2">
                            <c-select name="saas_ids" multiple async @search="searchSaas"></c-select>
                        </m-search-item>
                        <m-search-item label="商户代码">
                            <c-input name="saas_id" maxlength="20"></c-input>
                        </m-search-item>
                        <m-search-item label="商户全称">
                            <c-input name="saas_full_name" maxlength="20"></c-input>
                        </m-search-item>
                        <m-search-item label="联系人">
                            <c-input name="saas_contact_person" maxlength="20"></c-input>
                        </m-search-item>
                        <m-search-item label="联系电话">
                            <c-input name="saas_contact_phone" maxlength="20"></c-input>
                        </m-search-item>
                        <m-search-item label="商户类型">
                            <c-select name="merchant_type" :options="MERCHANT_TYPE"></c-select>
                        </m-search-item>
                        <m-search-item label="开通版本">
                            <c-select name="version_id" :options="versionOptions"></c-select>
                        </m-search-item>
                    </m-search>
                    <!-- 销售账单汇总统计 -->
                    <div class="stats-bar flex">
                        <div class="stats-card card-blue">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">同售积分合计</span>
                                    <span class="stats-value">{{formatPoints(summary.total_channel_points)}}</span>
                                </div>
                            </div>
                            <div class="stats-icon">积分</div>
                        </div>
<!--                        <div class="stats-card card-blue">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">IMEI积分合计</span>
                                    <span class="stats-value">{{formatPoints(summary.total_imie_points)}}</span>
                                </div>
                            </div>
                            <div class="stats-icon">积分</div>
                        </div>-->
                        <div class="stats-card card-orange">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">同售账户合计</span>
                                    <span class="stats-value">￥{{ formatMoney(summary.total_cash_balance) }}</span>
                                </div>
                            </div>
                            <div class="stats-icon">¥</div>
                        </div>
                        <div class="stats-card card-orange">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">通联账户合计</span>
                                    <span class="stats-value">￥{{ formatMoney(summary.total_balance) }}</span>
                                </div>
                            </div>
                            <div class="stats-icon">¥</div>
                        </div>
                        <div class="stats-card card-orange">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">保证金合计</span>
                                    <span class="stats-value">￥{{ formatMoney(summary.total_deposit_balance) }}</span>
                                </div>
                            </div>
                            <div class="stats-icon">¥</div>
                        </div>
                    </div>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_finance_saas_account_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <!--通联余额-->
                <template #balance="{data}">
                    ￥{{data.balance}}
                </template>
                <!--三方同售账户余额-->
                <template #cash_balance="{data}">
                    ￥{{data.cash_balance}}
                </template>
                <!--保证金余额-->
                <template #deposit_balance="{data}">
                    ￥{{data.deposit_balance}}
                </template>
                <!--商户类型-->
                <template #merchant_type="{data}">
                    <c-state tag async dict="MERCHANT_TYPE" :value="data.merchant_type"></c-state>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="180"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button  v-if="auth('b_finance_saas_account_deduction_4')" icon="tf-edit-sum" @click="$refs.accountDeduction.open(data,4,data.saas_id)">渠道积分充值/扣减</c-table-button>
                        <c-table-button  v-if="auth('b_finance_saas_account_deduction_5')" icon="tf-edit-sum" @click="$refs.accountDeduction.open(data,5,data.saas_id)">IMEI积分充值/扣减</c-table-button>
                        <c-table-button  v-if="auth('b_finance_saas_account_deduction_3')" icon="tf-edit-sum" @click="$refs.accountDeduction.open(data,3,data.saas_id)">保证金充值/扣减</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--提现审批弹窗-->
            <account-deduction ref="accountDeduction" @resolve="$refs.view.update()"></account-deduction>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'
import accountDeduction from "@/pages/finance/saas_account_deduction.vue";

export default {
    name:'p_finance_saas_account',

    components: {
        accountDeduction
    },

    data() {
        return {
            workType: 105,
            balance:0,
            payEnabled:true,
            ids:[],
            summary: {},
            withdraw_account_type:0, //账户类型 1=通联账户  2=三方同售账户
            versionOptions:[]
        }
    },

    mounted() {
        this.initSaasVersion();
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo']),
        ...asyncMapState(['MERCHANT_TYPE'])
    },

    methods: {
        /**
         * 金额格式化（保留两位小数）
         */
        formatMoney(val) {
            if (val === undefined || val === null || val === '') {
                return '0.00';
            }
            const num = parseFloat(val);
            return isNaN(num) ? '0.00' : num.toFixed(2);
        },
        /**
         * 积分格式化（积分无单位换算，直接展示数值）
         */
        formatPoints(val) {
            if (val === undefined || val === null || val === '') {
                return '0';
            }
            const num = parseFloat(val);
            return isNaN(num) ? '0' : num.toLocaleString();
        },
        /*******加载版本下拉框数据*****************/
        initSaasVersion() {
            this.request({
                url: '/sys_saas/version/list',
                data: {},
                success: data => {
                    this.versionOptions = data.map(item => {
                        return {
                            name: item.version_name,
                            value: item.id,
                            data: item
                        }
                    })
                }
            })
        },
        /*******搜索商户*****************/
        searchSaas(keyword, resolve){
            this.request({
                url:'/sys_saas/options',
                data: {
                    keyword: keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },
        /*********加载汇总统计（随列表查询条件联动）**********/
        loadSummary(listData, searchParams) {
            this.request({
                url: '/account/summary',
                data: searchParams || {},
                success: data => {
                    this.summary = data || {};
                }
            });
        },
    }
}
</script>


<style lang="stylus" scoped>
.stats-bar {
    flex-shrink: 0;
    gap: 10px;
    border-top: 1px solid #F5F5F5;
    padding: 8px 12px;

    .stats-card {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        max-width: 360px;
        min-height: 56px;
        padding: 8px 16px;
        border-radius: 6px;
        color: #fff;
        box-sizing: border-box;
        overflow: hidden;

        &.card-blue {
            background: linear-gradient(90deg, #2563eb, #3b82f6);
        }

        &.card-orange {
            background: linear-gradient(90deg, #f97316, #fb923c);
        }

        &.card-green {
            background: linear-gradient(90deg, #16a34a, #22c55e);
        }

        .stats-info {
            position: relative;
            z-index: 1;

            .stats-title-row {
                display: flex;
                align-items: baseline;
                line-height: 24px;

                .stats-label {
                    font-size: 12px;
                    opacity: 0.95;
                }

                .stats-value {
                    margin-left: 6px;
                    font-size: 18px;
                    font-weight: bold;
                }
            }

            .stats-summary-row {
                gap: .5em;
                margin-top: 2px;
                font-size: 11px;

                ins {
                    text-decoration: none;
                    opacity: 0.6;
                }

                label {
                    opacity: 0.9;
                }
            }
        }

        .stats-icon {
            position: absolute;
            right: 14px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 32px;
            line-height: 1;
            opacity: 0.15;

            .tf {
                font-size: 32px;
            }
        }
    }
}

.factory {
    border: 1px solid var(--unit-line);
    border-radius: 0 10px 10px 10px;
    border-top: none;
    padding: 26px;
    margin: 0 15px 15px;
    overflow: auto;
    background: #fff;

    &-tab {
        margin: 0 15px;

        >>> ul {
            padding-left: 0;
        }
    }

    &-logo {
        margin-right: 28px;

        &-image {
            position: relative;
            width: 100px;
            height: 100px;
            font-size: 24px;
            color: #ccc;
            background: #242738;

            &:hover {
                color: var(--color-main);

                .factory-logo-handle {
                    display: flex;
                }
            }
        }

        &-handle {
            gap: 20px;
            display: none;
            position: absolute;
            inset: 0;
            font-size: 20px;
            color: #fff;
            background: rgba(0,0,0,.6);

            a {
                font-size: 20px;

                &:hover {
                    color: var(--color-main);
                }
            }
        }

        &-name {
            gap: 5px;
            margin-top: 10px;
            font-size: 13px;
            color: #666;
        }
    }

    &-name {
        height: 32px;
        gap: 12px;

        p {
            font-size: 22px;
            font-weight: bold;
        }

        a {
            font-size: 20px;
            color: var(--color-main);
        }

        input {
            box-sizing: border-box;
            width: 200px;
            height: 100%;
            border: 1px solid #ccc;
            padding: 0 10px;

            &:focus {
                border-color: var(--color-main);
            }
        }

        >>> .c-button {
            height: 32px !important;
        }
    }

    &-code {
        display: inline-block;
        border: 1px solid #ddd;
        border-radius: 15px;
        padding: 0 16px;
        margin-top: 10px;
        line-height: 28px;
        font-size: 14px;
    }

    &-info {
        margin-top: 34px;

        td {
            height: 36px;
            font-size: 14px;

            &:nth-child(1) {
                color: #666;
            }

            &:nth-child(2) {
                padding-left: 20px;
            }

            .edition {
                border-radius: 4px;
                padding: 0 8px;
                margin-right: 10px;
                line-height: 24px;
                font-size: 13px;
                color: #fff;
                background: #F5F5F5;
            }

            .tag {
                border-radius: 4px;
                padding: 0 12px;
                margin: 0 10px;
                line-height: 26px;
                font-size: 15px;
                font-weight: bold;
                background: #F5F5F5;

                span {
                    color: var(--color-main);
                }
            }
        }
    }

    &-handle {
        gap: 20px;
        margin-top: 20px;

        >>> .c-button {
            border-radius: 4px;
        }
    }
}

.templet-list {
    gap: 20px;
    box-sizing: border-box;
    padding: 20px;

    .item {
        width: 300px;
        border-radius: 6px;
        overflow: hidden;
        background: #F9F9F9;
        transition: box-shadow .3s ease;

        &:hover {
            box-shadow: 0 0 10px 2px rgba(0,0,0,.1);
        }

        .cover {
            height: 200px;
            overflow: hidden;

            .image {
                height: 100%;
                background-size: cover;
                background-position: center;
                transition: transform .3s ease;

                ^[-2]:hover ^[-2..-1] {
                transform: scale(1.2);
            }
            }
        }

        .info {
            padding: 6px 25px 0;

            h5 {
                line-height: 50px;
                font-size: 18px;
            }

            ul {
                li {
                    position: relative;
                    padding: 6px 0 6px 24px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #666;

                    .tf {
                        position: absolute;
                        left: 0;
                        top: 0;
                        line-height: 32px;
                        font-size: 15px;
                        color: var(--color-main);
                    }
                }
            }
        }

        .button {
            padding: 16px 0 20px;

            >>> .c-button {
                width: 108px;
                height: 36px !important;
            }
        }
    }
}

.data-type {
    gap: 15px;
    padding: 20px;

    li {
        position: relative;
        border: 1px solid #F5F5F5;
        border-radius: 4px;
        padding: 20px;
        background: #F5F5F5;
        cursor: pointer;

        h5 {
            margin-bottom: 14px;
            font-size: 16px;
            font-weight: normal;
        }

        p {
            line-height: 22px;
        }

        &.z-crt,
        &:hover {
            border-color: var(--color-main);
            background: #fff;
        }

        &.z-crt {
            &:before {
                content: '';
                position: absolute;
                right: 0;
                top: 0;
                border-top: 24px solid var(--color-main);
                border-left: 28px solid rgba(0,0,0,0);
            }

            &:after {
                content: '\e63f';
                position: absolute;
                right: 2px;
                top: 2px;
                font-family: 'iconfont';
                font-size: 10px;
                color: #fff;
            }
        }
    }
}

.notice {
    &-delete {
        padding: 5px;
        font-size: 15px;
        color: #f00;

        &:hover {
            border-radius: 4px;
            background: #F5F5F5;
        }
    }

    &-temp {
        height: 520px;

        &-tip {
            margin-left: 20px;
        }
    }

    &-guide {
        align-self: flex-start;
        position: sticky;
        top: 0;
        padding: 26px 30px 20px;
        background: #FAFAFA;

        &-tip {
            margin-bottom: 12px;
            font-size: 13px;
            color: #f55;
        }

        &-arrow {
            position: relative;
            width: 60px;
            height: 1px;
            margin: 90px 16px 0;
            background: #999;

            &:after {
                content: '';
                position: absolute;
                right: 0;
                top: -5px;
                border-left: 10px solid #999;
                border-top: 5px solid rgba(0,0,0,0);
                border-bottom: 5px solid rgba(0,0,0,0);
            }
        }

        &-item {
            width: 180px;

            img {
                height: 180px;
            }

            p {
                margin: 14px 0 10px;
                font-size: 14px;
                font-weight: bold;
                white-space: nowrap;
                color: #f55;
            }

            span {
                line-height: 20px;
                font-size: 13px;
                color: #999;
            }
        }
    }
}
</style>